import { Button, Descriptions, Image, Typography } from "antd";
import React, { useContext, useState } from "react";
import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { NotificationInfo } from "../../../context";
import axios from "axios";

const CustomerOrderDialog = ({
  selectedData,
  close,
  getAllExistingOrder,
  merchant_id,
}) => {
  const [count, setCount] = useState(1);
  const tranxID = localStorage.getItem("tranxID");
  const { rerunNotif } = useContext(NotificationInfo);

  const handleAddProduct = () => {
    const formdata = new FormData();
    formdata.append("transaction_id", tranxID);
    formdata.append("merchant_id", merchant_id);
    formdata.append("commissary_id", selectedData.commissary_id);
    formdata.append("product_id", selectedData.id);
    formdata.append("product", selectedData.product);
    formdata.append(
      "description",
      selectedData.description === "null" ? "" : selectedData.description
    );
    formdata.append("price", selectedData.price);
    formdata.append("quantity", count);
    // setLoading(true);
    axios
      .post("customer/new-order", formdata)
      .then((response) => {
        const data = response.data;
        // // console.log("DATA", data)
        if (data === "success") {
          rerunNotif("success", "Added product successfully.");
          setTimeout(() => {
            close();
            getAllExistingOrder();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  return (
    <>
      {selectedData.product_image !== null && (
        <Descriptions
          title=""
          // title="Product Image"
          column={1}
          style={{ marginTop: 20 }}
        >
          <div>
            <Image
              width={window.innerWidth > 575 ? "auto" : "100%"}
              height={window.innerWidth > 575 ? 100 : "auto"}
              src={
                selectedData.product_image !== null
                  ? `${process.env.REACT_APP_API_IMAGE}products/${selectedData.product_image}`
                  : require("./../../../assets/empty.png")
              }
              placeholder={"logo"}
              preview={selectedData.product_image !== null ? true : false}
            />
          </div>
        </Descriptions>
      )}

      <Descriptions
        title=""
        // title="Product Info"
        column={1}
        style={{ marginTop: 10 }}
      >
        <Descriptions.Item
          label="Product"
          contentStyle={{
            fontWeight: "bold",
          }}
        >
          {selectedData.product}
        </Descriptions.Item>
        <Descriptions.Item
          label="Description"
          contentStyle={{
            fontWeight: "bold",
          }}
        >
          {selectedData.description}
        </Descriptions.Item>
        <Descriptions.Item
          label="Price"
          contentStyle={{
            fontWeight: "bold",
          }}
        >
          &#8369;{selectedData.price}
        </Descriptions.Item>
        <Descriptions.Item
          label="Status"
          contentStyle={{
            fontWeight: "bold",
            color: parseInt(selectedData.status) === 1 ? "green" : "red",
          }}
        >
          {parseInt(selectedData.status) === 1 ? "Available" : "Unavailable"}
        </Descriptions.Item>
      </Descriptions>

      <div style={{ border: "1px solid #e5e5e5", marginBottom: 10 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            type="dashed"
            shape="circle"
            onClick={() => {
              setCount(count - 1);
            }}
            icon={<MinusCircleOutlined />}
            disabled={count === 1 ? true : false}
          />
          <Typography.Title
            level={4}
            style={{ marginLeft: 10, marginRight: 10, marginTop: 10 }}
          >
            {count}
          </Typography.Title>
          <Button
            type="dashed"
            shape="circle"
            onClick={() => {
              setCount(count + 1);
            }}
            icon={<PlusCircleOutlined />}
            // disabled={count === 1 ? true : false}
          />
        </div>
      </div>

      <div>
        <Button
          type="primary"
          //   shape="circle"
          onClick={handleAddProduct}
          icon={<CheckOutlined />}
          // disabled={count === 1 ? true : false}
          style={{ width: "100%" }}
          size="large"
        >
          Add
        </Button>
      </div>
    </>
  );
};

export default CustomerOrderDialog;
